import { ClientUser } from '@he-novation/config/types/client.types';
import { EventUser, HerawEvent, HerawEventProject } from '@he-novation/config/types/event.types';
import { Project } from '@he-novation/config/types/project.types';
import { Task } from '@he-novation/config/types/task.types';
import { DragType } from './ScrollCalendar.hooks';

import { BaseClientLabel, ClientEventLabel } from '$types/clientTypes';
import { ContactType } from '$types/contactTypes';
import { Item } from '$types/items';

export type ScrollCalendarRowDataType =
    | {
          users: EventUser[];
      }
    | { labels: ClientEventLabel[] }
    | { project: HerawEventProject }
    | { items: Item[] }
    | null;

export type ScrollCalendarRowType = {
    unAssigned?: boolean;
    label: React.ReactNode;
    filterString: string;
    items: ScrollCalendarItemType[];
    data: ScrollCalendarRowDataType;
    filterGrouper?: string[]; // array of labels uuids for grouper filtering
};

type BaseScrollCalendarItem = HerawEvent & {
    level?: number;
    isTask?: boolean;
    task?: Task;
    editionType?: DragType;
    save?: HerawEvent;
};

export type ScrollCalendarItemType =
    | (BaseScrollCalendarItem & {
          recurringIndex?: number;
          isDraft: true;
          edits: { [k: string]: string | number | boolean | null };
          save: HerawEvent;
      })
    | (BaseScrollCalendarItem & {
          recurringIndex?: number;
          isDraft?: false;
          edits?: { [k: string]: string | number | boolean | null };
      });

export enum CalendarZoom {
    Day = 'Day',
    Days = 'Days',
    Weeks = 'Weeks',
    Months = 'Months'
    // Quarters = 'Quarters'
}

export type TimeSlot = {
    start: number;
    end: number;
};

export type GlobalRowsType = {
    users?: (ClientUser | ContactType)[];
    labels?: BaseClientLabel[];
    items?: Item[];
    projects?: Project[];
};

export enum CalendarItemColorType {
    Project = 'Project',
    Label = 'Label',
    Entity = 'Entity'
}

export enum CalendarFilterEnum {
    Teams = 'Teams',
    Labels = 'Labels',
    Authors = 'Authors'
}

export enum ScrollCalendarGrouper {
    Users = 'users',
    Labels = 'labels',
    Projects = 'projects',
    Items = 'items'
}

export type CalendarPreferences = {
    grouper?: ScrollCalendarGrouper;
    itemColorType?: CalendarItemColorType;
    timeSlots?: TimeSlot;
};
